var map = {
	"./aave-governance-power/examples.json": "00ba",
	"./aavegotchi/examples.json": "3551",
	"./apescape/examples.json": "63c7",
	"./api/examples.json": "e95e",
	"./avn-balance-of-staked/examples.json": "8416",
	"./balance-of-with-min/examples.json": "2f04",
	"./balancer-delegation/examples.json": "7272",
	"./balancer-unipool/examples.json": "a415",
	"./balancer/examples.json": "18b2",
	"./brightid/examples.json": "86d8",
	"./celer-sgn-delegation/examples.json": "f072",
	"./comp-like-votes/examples.json": "b126",
	"./contract-call/examples.json": "1aad",
	"./cream/examples.json": "20f7",
	"./curio-cards-erc20-weighted/examples.json": "4f95",
	"./decentraland-estate-size/examples.json": "c526",
	"./defidollar/examples.json": "98bf",
	"./delegation/examples.json": "6f87",
	"./dittomoney/examples.json": "faff",
	"./ens-domains-owned/examples.json": "a635",
	"./ens-reverse-record/examples.json": "3e98",
	"./erc1155-all-balances-of/examples.json": "9688",
	"./erc1155-balance-of-cv/examples.json": "a18b",
	"./erc1155-balance-of/examples.json": "35aa",
	"./erc20-balance-of-delegation/examples.json": "f66f",
	"./erc20-balance-of/examples.json": "1117",
	"./erc20-price/examples.json": "c695",
	"./erc20-received/examples.json": "b4d6",
	"./erc20-with-balance/examples.json": "31b3",
	"./erc721-enumerable/examples.json": "5d55",
	"./erc721-with-multiplier/examples.json": "4254",
	"./erc721/examples.json": "58d9",
	"./esd-delegation/examples.json": "3444",
	"./esd/examples.json": "6b5e",
	"./eth-philanthropy/examples.json": "08bf",
	"./eth-received/examples.json": "41bf",
	"./eth-wallet-age/examples.json": "805c",
	"./flashstake/examples.json": "cf17",
	"./frax-finance/examples.json": "a191",
	"./governor-alpha/examples.json": "ff78",
	"./hopr-uni-lp-farm/examples.json": "e30a",
	"./inverse-xinv/examples.json": "e426",
	"./iotex-balance/examples.json": "09ad",
	"./liftkitchen/examples.json": "27fd",
	"./masterchef-pool-balance/examples.json": "c11b",
	"./masterchef/examples.json": "0af0",
	"./mithcash/examples.json": "1df0",
	"./modefi/examples.json": "a0bb",
	"./moloch-all/examples.json": "d1268",
	"./moloch-loot/examples.json": "e3a6",
	"./multichain/examples.json": "4da81",
	"./multisig-owners/examples.json": "3e94",
	"./mushrooms/examples.json": "9a3e",
	"./niu-staked/examples.json": "85ba",
	"./ocean-marketplace/examples.json": "fe4c",
	"./opium/examples.json": "c359",
	"./pagination/examples.json": "a1ff",
	"./pepemon/examples.json": "cc91",
	"./piedao/examples.json": "0a47",
	"./pob-hash/examples.json": "30de",
	"./rebased/examples.json": "10dc",
	"./ren-nodes/examples.json": "6dfb",
	"./rnbw-balance/examples.json": "79a9",
	"./ruler-staked-lp/examples.json": "8fd5",
	"./saffron-finance/examples.json": "eb95",
	"./spookyswap/examples.json": "62db",
	"./stablexswap/examples.json": "aa7b",
	"./staked-keep/examples.json": "43a9",
	"./staked-uniswap/examples.json": "03a2",
	"./sushiswap/examples.json": "6f56",
	"./synthetix/examples.json": "7f9a1",
	"./the-graph-balance/examples.json": "9874",
	"./the-graph-delegation/examples.json": "0aae",
	"./the-graph-indexing/examples.json": "f12a",
	"./ticket-validity/examples.json": "e688",
	"./ticket/examples.json": "8f8d",
	"./tokenlon/examples.json": "3bf7",
	"./total-axion-shares/examples.json": "1234",
	"./tranche-staking-lp/examples.json": "fafe",
	"./tranche-staking/examples.json": "8e03",
	"./typhoon/examples.json": "0342",
	"./uniswap/examples.json": "c93b",
	"./whitelist/examples.json": "4505",
	"./work/examples.json": "da75",
	"./xcover/examples.json": "a320",
	"./xdai-easy-staking/examples.json": "d431",
	"./xdai-posdao-staking/examples.json": "413e",
	"./xdai-stake-delegation/examples.json": "3833",
	"./xdai-stake-holders/examples.json": "e9ab",
	"./xdai-stakers-and-holders/examples.json": "a9fd",
	"./xrc20-balance-of/examples.json": "05c0",
	"./xseen/examples.json": "17e5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ea05";